import { render, staticRenderFns } from "./TradingChart.vue?vue&type=template&id=193f08a2&scoped=true&"
import script from "./TradingChart.vue?vue&type=script&lang=js&"
export * from "./TradingChart.vue?vue&type=script&lang=js&"
import style0 from "./_chartShared.scss?vue&type=style&index=0&id=193f08a2&scoped=true&lang=scss&"
import style1 from "./TradingChart.vue?vue&type=style&index=1&id=193f08a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f08a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
